/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:42:21
 * @Description: file content
 */ 
import React, { Component } from 'react';
//import OriginCascader from 'bee-cascader';
import { Cascader as OriginCascader } from '@tinper/next-ui';
import './index.less';
//require('bee-cascader/build/Cascader.css');

class Cascader extends Component {
    render() {
        const { className = '', popupClassName = '', ...others } = this.props;
        return <OriginCascader className={`base-cascader-wrapper ${className}`} popupClassName={`base-cascader-menu ${popupClassName}`} {...others}/>;
    }
}
export default Cascader;
